if (!customElements.get('ap-press-marquee')) {
  customElements.define('ap-press-marquee', class extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('[data-press-group]');
      this.track = this.querySelector('[data-press-track]');
      this.toggle = this.querySelector('button');
      if (!this.group || !this.group.children.length) return;

      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onToggle = () => {
        const paused = this.toggleAttribute('data-paused');
        this.toggle.setAttribute('aria-pressed', String(paused));
      };
      this.toggle.addEventListener('click', this.onToggle);
      this.rebuild = () => {
        this.track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
        this.removeAttribute('data-ready');
        this.toggle.hidden = true;
        if (this.motion.matches) return;
        const width = this.group.getBoundingClientRect().width;
        if (!width || !this.clientWidth) return;
        // One extra full sequence covers both ends throughout the animation.
        const copies = Math.ceil(this.clientWidth / width) + 1;
        for (let index = 0; index < copies; index += 1) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-press-group');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          this.track.appendChild(clone);
        }
        this.setAttribute('data-ready', '');
        this.toggle.hidden = false;
      };
      this.motion.addEventListener('change', this.rebuild);
      this.resize = new ResizeObserver(this.rebuild);
      this.resize.observe(this);
      this.resize.observe(this.group);
      this.visibility = new IntersectionObserver(entries => {
        this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
      });
      this.visibility.observe(this);
      this.rebuild();
    }

    disconnectedCallback() {
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.motion?.removeEventListener('change', this.rebuild);
      this.toggle?.removeEventListener('click', this.onToggle);
    }
  });
}
